// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import translate from "@insite/client-framework/Translate";
import { TextFieldProps } from "@insite/mobius/TextField";
import { css } from "styled-components";

promotionCodeFormStyles.textAndButtonWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        width: 100%;
    `,
};

promotionCodeFormStyles.promotionCodeGridItem = {
    css: css`
        align-items: flex-end;
        flex-grow: 1;
    `,
};

promotionCodeFormStyles.gridContainer = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: flex-start;
        flex-direction: column;
    `
}

promotionCodeFormStyles.promotionCodeTextField = {
    placeholder: translate("Add Promo Code"),
} as TextFieldProps;

promotionCodeFormStyles.promotionRemovedText = {
    size: fontConfig.singleLinexSmall.size,
    lineHeight: fontConfig.singleLinexSmall.lineHeight,
    weight: fontConfig.weight.regular,
};

promotionCodeFormStyles.applyPromotionGridItem = {
    css: css`
        display: flex;
        align-items: flex-start;
        margin-top: 23px !important;
        justify-content: end;
    `,
};

promotionCodeFormStyles.applyButton = {
    variant: "primary",
    css: css`
    `,
};
promotionCodeFormStyles.removeCodeGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    `,
};
